module.exports = {
  api: require("./api"),
  app: require("./app"),
  auth: require("./auth"),
  backend: require("./backend"),
  chat: require("./chat"),
  file: require("./file"),
  folder: require("./folder"),
  group: require("./group"),
  guest: require("./guest"),
  install: require("./install"),
  invitation: require("./invitation"),
  licence: require("./licence"),
  member: require("./member"),
  profile: require("./profile"),
  project: require("./project"),
  public: require("./public"),
  registration: require("./registration"),
  repository: require("./repository"),
  role: require("./role"),
  service: require("./service"),
  theme: require("./theme"),
  user: require("./user")
}
